export default {
	passwordTexts: {
		notMatch: 'Passwords do not match',
		notValid: 'Min 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 symbol',
	},
};
